"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCoreHeadlineProps = exports.RenderHeadline = exports.Headline = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var CoreHeadline_1 = require("./CoreHeadline");
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var WrappedHeadline = sdk_ui_1.withContexts(RenderHeadline);
/**
 * [Headline](https://sdk.gooddata.com/gooddata-ui/docs/headline_component.html)
 * Headline shows a single number or compares two numbers. You can display both measures and attributes.
 *
 * Headlines have two sections: Measure (primary) and Measure (secondary).
 * You can add one item to each section. If you add two items, the headline also displays the change in percent.
 *
 * @public
 */
exports.Headline = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([props.primaryMeasure, props.secondaryMeasure, props.filters], props.placeholdersResolutionContext), primaryMeasure = _a[0], secondaryMeasure = _a[1], filters = _a[2];
    return react_1.default.createElement(WrappedHeadline, tslib_1.__assign({}, props, { primaryMeasure: primaryMeasure, secondaryMeasure: secondaryMeasure, filters: filters }));
};
function RenderHeadline(props) {
    ts_invariant_1.default(props.primaryMeasure, "The property primaryMeasure must be specified.");
    return react_1.default.createElement(CoreHeadline_1.CoreHeadline, tslib_1.__assign({}, toCoreHeadlineProps(props)));
}
exports.RenderHeadline = RenderHeadline;
function toCoreHeadlineProps(props) {
    var buckets = [
        sdk_model_1.newBucket(sdk_ui_1.BucketNames.MEASURES, props.primaryMeasure, props.secondaryMeasure),
    ];
    var newProps = omit_1.default(props, [
        "primaryMeasure",
        "secondaryMeasure",
        "filters",
        "backend",
    ]);
    return tslib_1.__assign(tslib_1.__assign({}, newProps), { execution: createExecution(buckets, props), exportTitle: props.exportTitle || "Headline" });
}
exports.toCoreHeadlineProps = toCoreHeadlineProps;
function createExecution(buckets, props) {
    var backend = props.backend, workspace = props.workspace, execConfig = props.execConfig;
    return backend
        .withTelemetry("Headline", props)
        .workspace(workspace)
        .execution()
        .forBuckets(buckets, props.filters)
        .withDimensions({ itemIdentifiers: ["measureGroup"] })
        .withExecConfig(execConfig);
}
//# sourceMappingURL=Headline.js.map